import { createSelector } from 'reselect';

import type { IAgronomyAgreementService, IAgronomyAgreementServicesState } from './types';

export const selectServiceCategories = createSelector(
  (state: IAgronomyAgreementServicesState) => state.categories,
  (categories) =>
    [...categories]
      .map((category) => ({
        ...category,
        services: [...(category.services ?? [])].sort((a, b) => a.sortOrder - b.sortOrder),
      }))
      .sort((a, b) => a.sortOrder - b.sortOrder),
);

export const selectIndexedAdditionalServices = createSelector(
  selectServiceCategories,
  (categories) =>
    categories
      .flatMap(({ services }) => services ?? [])
      .reduce<Record<string, IAgronomyAgreementService | undefined>>((indexed, service) => {
        if (service.serviceRef) {
          indexed[service.serviceRef] = service;
        }
        return indexed;
      }, {}),
);

export const selectAdditionalService = createSelector(
  [
    selectIndexedAdditionalServices,
    (_: IAgronomyAgreementServicesState, serviceRef: string) => serviceRef,
  ],
  (indexedServices, serviceRef) => indexedServices[serviceRef],
);
